import { Button, Grid, Stack, Typography } from "@mui/material";
import { sendPhoneOtp, verifyOtp } from "@ui/Auth/api";
import { StyledTextField } from "components/common/style-components/TextField/MuiTextField.component";
import { isEmpty, toString } from "lodash";
import React, { useEffect, useMemo, useState } from "react";
import { Controller, useFormContext } from "react-hook-form";
import { toast } from "react-hot-toast";
import { MdVerified } from "react-icons/md";
import { useAppAuth } from "store/auth-context";
import { getMainClient } from "utils/common/common.utils";
import { signupForm } from "utils/forms-constants/forms-constants.util";
import { CircularProgress } from "../../../../node_modules/@mui/material/index";

const BasicInfoStep = ({ basicStepFormVisited }) => {
  const [isMobileOTPsent, setIsMobileOTPsent] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isVerifyLoading, setIsVerifyLoading] = useState(false);
  const { isMobileVerified, setIsMobileVerified } = useAppAuth();

  const [otp, setOtp] = useState();

  const {
    control,
    formState: { errors },
    getValues,
    setValue,
    setError,
    clearErrors,
  } = useFormContext();
  const mainClient = getMainClient();
  const data = getValues();

  const { isMobileVerifySend, isOTPFilled } = useMemo(() => {
    return {
      isMobileVerifySend:
        !errors[signupForm.mobile]?.message && !isEmpty(data?.mobile),
      isOTPFilled: !isEmpty(data?.otp),
    };
  }, [errors, data]);

  const sendMobileOTP = async (mobile) => {
    try {
      setIsLoading(true);
      await sendPhoneOtp(mobile, {
        throwIfUserExist: true,
        client: mainClient?.id,
      });
      setIsMobileOTPsent(true);

      setIsMobileVerified(false);
      toast.success("Otp has been sent successfully");
    } catch (err) {
      toast.error(err?.response?.data?.message);
    } finally {
      setIsLoading(false);
    }
  };

  const verifyMobileOTP = async (phone, code) => {
    try {
      setIsVerifyLoading(true);
      await verifyOtp(phone, code);
      toast.success("OTP has been verified");
      setIsMobileVerified(true);
      setIsMobileOTPsent(false);
      setValue(signupForm.otp, "");
    } catch (err) {
      setIsMobileVerified(false);
      toast.error(err?.response?.data?.message);
    } finally {
      setIsVerifyLoading(false);
    }
  };

  const handleSendOtp = async () => {
    if (isMobileVerifySend) {
      sendMobileOTP(data?.mobile);
    }
  };
  const handleVerify = () => {
    const otpLength = otp?.length > 4 || otp?.length < 4;

    if (!otpLength && otp !== "") {
      verifyMobileOTP(data?.mobile, otp);
    } else {
      setError("otp", {
        type: "manual",
        message: "OTP must be typed",
      });
    }
  };

  useEffect(() => {
    if (!basicStepFormVisited && isMobileVerified) {
      setIsMobileVerified(false);
    }
  }, []);
  const handleChangeNumber = async () => {
    setIsMobileVerified(false);
  };

  useEffect(() => {
    if (isEmpty(data?.mobile)) {
      setIsMobileOTPsent(false);
    }
  }, [data]);

  return (
    <>
      <Grid item xs={12} md={6}>
        <Controller
          name={signupForm.first_name}
          control={control}
          rules={{ required: true }}
          render={({ field: { onChange, value } }) => (
            <StyledTextField
              fullWidth
              required
              id={signupForm.first_name}
              data-testid={signupForm.first_name}
              label="First Name"
              value={value}
              onChange={onChange}
              error={!!errors[signupForm.first_name]?.message}
              helperText={toString(errors[signupForm.first_name]?.message)}
            />
          )}
        />
      </Grid>
      <Grid
        item
        xs={12}
        md={6}
        sx={{
          display: "flex",
          justifyContent: "center",
        }}
      >
        <Controller
          name={signupForm.last_name}
          control={control}
          render={({ field: { onChange, value } }) => (
            <StyledTextField
              fullWidth
              required
              id={signupForm.last_name}
              data-testid={signupForm.last_name}
              label="Last Name"
              value={value}
              onChange={onChange}
              error={!!errors[signupForm.last_name]?.message}
              helperText={toString(errors[signupForm.last_name]?.message)}
            />
          )}
        />
      </Grid>
      <Grid
        item
        xs={12}
        md={6}
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Grid
          item
          xs={isMobileVerifySend && isMobileVerified === false ? 8 : 12}
          md={isMobileVerifySend && isMobileVerified === false ? 8 : 12}
        >
          <Controller
            name={signupForm.mobile}
            control={control}
            render={({ field: { onChange, value } }) => (
              <Stack alignItems="flex-start">
                <StyledTextField
                  fullWidth
                  id={signupForm.mobile}
                  data-testid={signupForm.mobile}
                  label="Mobile"
                  value={value}
                  onChange={onChange}
                  disabled={isMobileVerified}
                  error={!!errors[signupForm.mobile]?.message}
                  helperText={toString(errors[signupForm.mobile]?.message)}
                  InputProps={{
                    endAdornment: isMobileVerified ? (
                      <MdVerified style={{ color: "green", size: 6 }} />
                    ) : null,
                  }}
                />
                <Typography
                  onClick={handleChangeNumber}
                  sx={{
                    cursor: "pointer",
                    color: "#A54201",
                    fontWeight: 800,
                    fontSize: "0.8rem",
                    marginTop: "2px",
                  }}
                >
                  {isMobileVerified ? "Want to change mobile number?" : ""}
                </Typography>
              </Stack>
            )}
          />
        </Grid>
        {isMobileVerifySend && isMobileVerified === false ? (
          <Grid item xs={4}>
            {isLoading ? (
              <CircularProgress
                size={10}
                sx={{
                  color: "#040202",
                }}
              />
            ) : (
              <Button onClick={handleSendOtp}>
                {isMobileOTPsent ? "Resend otp" : "Send otp"}
              </Button>
            )}
          </Grid>
        ) : null}
      </Grid>
      {isMobileOTPsent ? (
        <Grid
          item
          xs={12}
          md={6}
          container
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Grid item xs={8}>
            <Controller
              name={signupForm.otp}
              control={control}
              rules={{ required: true }}
              render={({ field: { onChange, value } }) => (
                <StyledTextField
                  fullWidth
                  required
                  id={signupForm.otp}
                  data-testid={signupForm.otp}
                  label="OTP"
                  value={otp}
                  onChange={(e) => {
                    setOtp(e?.target?.value);
                  }}
                  error={!!errors[signupForm.otp]?.message}
                  helperText={toString(errors[signupForm.otp]?.message)}
                />
              )}
            />
          </Grid>
          <Grid item xs={4}>
            {isVerifyLoading ? (
              <CircularProgress
                size={10}
                sx={{
                  color: "#040202",
                }}
              />
            ) : (
              <Button onClick={handleVerify}>Verify otp</Button>
            )}
          </Grid>
        </Grid>
      ) : null}

      <Grid
        item
        xs={12}
        md={6}
        sx={{
          display: "flex",
          justifyContent: "center",
        }}
      >
        <Controller
          name={signupForm.email}
          control={control}
          render={({ field: { onChange, value } }) => (
            <StyledTextField
              required
              fullWidth
              id={signupForm.email}
              data-testid={signupForm.email}
              label="Email"
              value={value}
              onChange={onChange}
              error={!!errors[signupForm.email]?.message}
              helperText={toString(errors[signupForm.email]?.message)}
            />
          )}
        />
      </Grid>
    </>
  );
};

export default BasicInfoStep;
